<template>
  <v-navigation-drawer absolute app temporary right :value="showProfileMenu" class="menu-container">
    <div class="menu-top-icon-container">
      <v-btn flat icon @click="handleCloseProfileMenu">
        <v-icon class="menu-top-icon">close</v-icon>
      </v-btn>
      <v-icon class="menu-top-icon">account_circle</v-icon>
    </div>
    <v-list class="pt-0 profile-menu-list" dense>
      <v-list-tile v-if="!isLoggedIn" @click="$emit('handleLogin')">
        <v-list-tile-content>
          <v-list-tile-title class="profile-menu-list-login">Login</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <DrawerOption
        v-for="(item, index) in profileDrawerOptions"
        v-bind:key="index"
        v-bind:action="item.action"
        v-bind:title="item.title"
        v-bind:isHighlighted="item.isHighlighted"
        v-bind:dividerFollows="item.dividerFollows"
        v-bind:isDivider="item.isDivider || false"
      ></DrawerOption>
      <v-list-tile v-if="isLoggedIn" @click="handleLogout">
        <v-list-tile-content>
          <v-list-tile-title class="profile-menu-list-logout">Logout</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title class="profile-menu-list-version">Version {{ appVersion }} - {{ environment }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import DrawerOption from '../DrawerOption'
import { getProfile } from '../../utils/auth'
import '../../style/_variables.scss'

export default {
  name: 'profile-menu',
  props: ['profileDrawerOptions'],
  components: {DrawerOption},
  data () {
    return {
      isLoggedIn: getProfile() !== null,
      appVersion: String(process.env.VERSION) || '0.0.0',
      environment: process.env.NODE_ENV
    }
  },
  computed: {
    showProfileMenu: { get () { return this.$store.state.modalState.showProfileMenu } }
  },
  methods: {
    handleLogout () {
      this.isLoggedIn = false
      this.$emit('handleLogout')
    },
    handleCloseProfileMenu () {
      this.$store.commit('setShowProfileMenu', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-menu {
  &-list-login {
    color: $blue-primary;
  }
  &-list-logout {
    color: $error
  }
}
.profile-menu-list-version {
  text-transform: capitalize;
  color: #9e9e9e;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/ProfileMenu.vue